<template>
  <b-card-group deck>
    <b-alert
      v-model="showAlert"
      class="position-fixed fixed-top m-0 rounded-0"
      style="z-index: 2000;"
      variant="success"
      dismissible
    >
      {{alertMessage}}
    </b-alert>
    <!-- for loading page -->
    <app-loading :className="isLoading ? 'loading' : ''"></app-loading>
    <!--confirm box-->
    <app-confirm :message="'Delete?'" :show="showConfirmBox" @confirmed="confirmedDelete" @cancel="showConfirmBox=false" ></app-confirm>
    <div class="row appinfo-row">
      <!--Application information-->
      <b-card
        class="appinfopage"
        no-body
      >
        <div class="appinfo-button-row h4-title">
          <h4 class="h4-title-text">Application Information</h4>
          <b-button
            class="new-button-primary"
            @click="goToEditApp()"
          ><i class="fa fa-pencil icon-white"></i></b-button>
          <b-button
            class="new-button-primary"
            @click="copyAppDetail($event)"
            id="copyAppBtn"
          ><i class="fa fa-copy icon-white"></i></b-button>
          <b-tooltip
            ref="copyAppTooltip"
            target="copyAppBtn"
            placement="bottom"
          >
            <strong>{{tooltipTextCopyApp}}</strong>
          </b-tooltip>
          <b-button
            variant="danger"
            @click="requestDeleteConfirmBox('app')"
          ><i class="fa fa-trash icon-white"></i></b-button>
        </div>
        <b-card-body>
          <img
            class="thumbnail"
            :src="activeVersion.thumbnail"
            @error="altImg"
            id="iconThumbnail"
          >
          <div class="appdetail">
            <h5>{{currentApp.name}}</h5>
            <h6>{{activeVersion.version}}</h6>
            <h6>{{currentApp.description}}</h6>
            <div
              class="buttondownload"
              v-if="!currentApp.noVersion"
            >
              <b-button
                pill
                class="pill-color"
                @click="goToAppLanding()"
              >link to download</b-button>
            </div>
          </div>
        </b-card-body>
      </b-card>
    </div>
    <div class="row appinfo-row version-card-top-margin">
      <!----------------------->
      <!--Version Information-->
      <b-card
        class="version-card"
        no-body
      >
        <div class="versioninfo">
          <div class="appinfo-button-row h4-title">
            <h4 class="h4-title-text">Versions</h4>
            <b-button
              class="new-button-primary"
              @click="goToNewVersion()"
            ><i class="fa fa-plus icon-white"></i> </b-button>
            <b-button
              class="new-button-primary"
              @click="goToEditVersion()"
            ><i class="fa fa-pencil icon-white"></i></b-button>
            <b-button
              class="new-button-primary"
              @click="copyAppDetail($event)"
              id="copyAppBtn2"
            ><i class="fa fa-copy icon-white"></i></b-button>
            <b-tooltip
              ref="copyAppTooltip2"
              target="copyAppBtn2"
              placement="bottom"
            >
              <strong>{{tooltipTextCopyApp}}</strong>
            </b-tooltip>
            <b-button
              variant="danger"
              @click="requestDeleteConfirmBox('version')"
            ><i class="fa fa-trash icon-white"></i></b-button>
          </div>
          <b-row>
            <b-card
              no-body
              class="b-card-list-group"
            >
              <b-list-group
                class="list-group-scroll"
                flush
              >
                <b-list-group-item
                  @click="viewVersion(cv.id)"
                  :class="{'highlight': cv.id === activeId}"
                  v-for="cv in listAppVersions"
                  :key="cv.id"
                >Version <font style='font-weight: bolder'>{{cv.version}}</font></b-list-group-item>
              </b-list-group>
            </b-card>
            <b-card
              class="version-detail-card"
              no-body
            >
              <h4 class="h4-title version-title-small">{{currentVersionText}}
                <b-form-checkbox
                  v-model="current"
                  name="check-button"
                  class="current-switch-style"
                  switch
                  @change="seeCurrent()"
                >
                </b-form-checkbox>
              </h4>
              <hr>
              <b-card
                no-body
                class="version-detail-releasenotes"
              >
                <h6 class="whatsnew-style">What's New</h6>
                {{releaseNotes}}
              </b-card>
            </b-card>
            <b-card
              no-body
              class="pin-card"
            >
              <h4 class="pin-header">PIN</h4>
              <b-row class="pin-row">
                <label class="pin-label-style">{{activeVersion.pin}}</label>
                <b-button
                  class="new-button-primary pin-copy-btn-style"
                  @click="copyPin"
                  id="copyPinBtn"
                ><i class="fa fa-copy icon-white pin-copy-icon-style"></i>Copy PIN</b-button>
                <b-tooltip
                  ref="copyPinTooltip"
                  target="copyPinBtn"
                  class="blue-tip"
                  placement="bottom"
                >
                  <strong>{{tooltipTextCopyPIN}}</strong>
                </b-tooltip>
              </b-row>

            </b-card>
          </b-row>
        </div>
      </b-card>
    </div>
  </b-card-group>

</template>
<script>
import * as appstore from '@/helpers/appstore.js';
import * as general from '@/helpers/general.js';
import Loading from '@/components/Loading';
import ConfirmBox from '@/components/ConfirmBox';
import axios from 'axios';

export default {
  name: 'AppDetail',
  data () {
    return {
      currentApp: {},
      currentVersion: {},
      activeVersion: {},
      listAppVersions: [],
      appId: '',
      versionId: '',
      currentVersionText: 'Current Version',
      tooltipTextCopyApp: 'Copy App Detail',
      tooltipTextCopyPIN: 'Copy PIN',
      delTarget: '',
      alertMessage: '',
      altImage: require('@/assets/notavailable.png'),
      images: [],
      saveDone: false,
      loading: false,
      isLoading: false,
      isDetail: false,
      showCarousel: false,
      isAdmin: false,
      current: true,
      noVersion: false,
      showAlert: false,
      showConfirmBox: false,
      activeId: null
    };
  },
  created: function () {
    document.title = 'Admin Console: App Detail';
    this.getAppData();
  },
  computed: {
    releaseNotes () {
      return appstore.getReleaseNotes(this.activeVersion);
    }
  },
  mounted: function () {
    this.isAdmin = general.isAdmin();
  },
  methods: {
    getAppData () {
      this.isLoading = true;
      this.appId = this.$route.params.id;
      this.isDetail = !!this.appId;
      if (this.isDetail) {
        this.currentApp = JSON.parse(sessionStorage.getItem('app'));
        if (false === this.currentApp.noVersion) {
          this.axios.get(process.env.VUE_APP_URL_UNIVERSAL_API + `/app-store/app/${this.appId}/version`, {
            headers: {
              Accept: 'application/json'
            }
          }).then(response => {
            let versions = response.data.data.versions;
            this.listAppVersions = versions;
            let currentVersionIndex = this.listAppVersions.findIndex(this.findVersion);
            if (currentVersionIndex < 0) {
              currentVersionIndex = 0;
              this.currentVersionText = 'Lastest Version';
            }
            this.activeVersion = this.listAppVersions[currentVersionIndex];
            this.currentVersion = this.activeVersion;
            this.currentVersion = appstore.getPreviousVersion(currentVersionIndex, this.currentVersion, this.listAppVersions);
            this.activeId = this.activeVersion.id;
          }).catch(error => {
            console.log(error);
          });
        }
        this.isLoading = false;
      }
    },
    findVersion (v) {
      return v.id === this.versionId;
    },
    goToAppLanding () {
      let routeToAppLanding = this.getRouteToLanding();
      window.open(routeToAppLanding.href, '_blank');
    },
    getRouteToLanding () {
      return this.$router.resolve({ name: 'appsLanding', params: { appid: this.appId, versionid: this.activeVersion.id } });
    },
    altImg (e) {
      e.target.src = this.altImage;
    },
    viewVersion (id) {
      this.versionId = id;
      this.activeVersion = this.listAppVersions.find(this.findVersion);
      this.activeVersion = appstore.getPreviousVersion(this.listAppVersions.findIndex(this.findVersion), this.activeVersion, this.listAppVersions);
      this.activeId = id;
      this.current = false;
      if (this.activeVersion.isCurrent) {
        this.current = true;
      }
    },
    seeCurrent () {
      this.activeVersion = this.currentVersion;
      this.versionId = this.activeVersion.id;
      this.activeId = this.versionId;
      this.current = true;
    },
    setCarouselImages (screenshots) {
      this.images = [];
      for (let i = 0; i < screenshots.length; i++) {
        let screenshot = screenshots[i];
        this.images.push({
          id: screenshot.id,
          big: screenshot.url,
          thumb: screenshot.url
        });
      }
      this.showCarousel = screenshots.length > 0;
    },
    deleteApp () {
      if (this.appId) {
        axios({
          method: 'delete',
          url: (process.env.VUE_APP_URL_UNIVERSAL_API + '/app-store/app/' + this.appId)
        }).then(res => {
          const receivedResp = res.data;
          if ('Success' === receivedResp.message) {
            this.removeSessionStorageApp();
            this.alertMessage = 'Application has been successfully deleted.';
            this.showAlert = true;
            this.$router.push({ name: 'apps-home' });
          }
        })
          .catch(error => console.log(error));
      }
    },
    deleteVersion () {
      axios({
        method: 'delete',
        url: (process.env.VUE_APP_URL_UNIVERSAL_API + '/app-store/app/' + this.appId + '/version/' + this.activeVersion.id)
      }).then(res => {
        const receivedResp = res.data;
        if ('Success' === receivedResp.message) {
          this.alertMessage = 'Selected version has been successfully deleted.';
          this.showAlert = true;
          this.$router.push({ name: 'apps-home' });
        }
      })
        .catch(error => console.log(error));
    },
    confirmedDelete () {
      if ('app' === this.delTarget) {
        this.deleteApp();
      } else if ('version' === this.delTarget) {
        this.deleteVersion();
      }
    },
    requestDeleteConfirmBox (t) {
      this.delTarget = t;
      this.showConfirmBox = true;
    },
    goToNewVersion () {
      this.$router.push({ name: 'apps-version', params: { id: this.appId } });
    },
    goToEditVersion () {
      this.$router.push({ name: 'app-version-edit', params: { id: this.appId, versionid: this.activeVersion.id } });
    },
    goToEditApp () {
      this.$router.push({ name: 'apps-edit', params: { id: this.appId } });
    },
    goToNewApp () {
      this.$router.push({ name: 'apps-create' });
    },
    copyAppDetail (e) {
      let fullUrl = window.location.origin + this.getRouteToLanding().href;
      let fullTextToCopy = this.currentApp.name + ' ' + this.activeVersion.version + ' \r\n' + fullUrl + ' \r\nPIN : ' + this.activeVersion.pin;
      this.$clipboard(fullTextToCopy);

      let btnId = e.currentTarget.id;
      this.tooltipTextCopyApp = 'Copied!';
      if ('copyAppBtn2' === btnId) {
        this.$refs.copyAppTooltip2.$emit('open');
      }
      if ('copyAppBtn' === btnId) {
        this.$refs.copyAppTooltip.$emit('open');
      }
      setTimeout(() => {
        this.tooltipTextCopyApp = 'Copy App Detail';
      }, 3000);
    },
    copyPin () {
      this.$clipboard(this.activeVersion.pin);
      this.tooltipTextCopyPIN = 'Copied!';
      this.$refs.copyPinTooltip.$emit('open');
      setTimeout(() => {
        this.tooltipTextCopyPIN = 'Copy PIN';
      }, 5000);
    },
    removeSessionStorageApp () {
      sessionStorage.removeItem('app');
    }
  },
  watch: {
    '$route' (to, from) {
      this.getAppData();
    }
  },
  components: {
    'app-loading': Loading,
    'app-confirm': ConfirmBox
  }
};
</script>
<style scoped src="@/assets/css/appstore-detail.css"></style>
